import { defineQuery } from 'bitecs';
import { Hunger, Thirst, Position, Tile } from '../world.js';
import { PLAYER_STATS } from '../config.js';

const TILE_SIZE = 16;
const playerQuery = defineQuery([Hunger, Thirst, Position]);
const tileQuery = defineQuery([Tile]);

function getTileAtPosition(world, x, y) {
    const tiles = tileQuery(world);
    const tileX = Math.floor(x / TILE_SIZE);
    const tileY = Math.floor(y / TILE_SIZE);
    
    for (const tile of tiles) {
        if (Tile.x[tile] === tileX && Tile.y[tile] === tileY) {
            return tile;
        }
    }
    return null;
}

export function hungerSystem(world) {
    const players = playerQuery(world);
    const time_delta = world.delta || 16.67; // Default to ~60fps if delta not provided
    const seconds_elapsed = time_delta / 1000; // Convert ms to seconds
    
    for (const player of players) {
        // Get the correct hunger rate from the dynamically calculated getter
        const hungerRate = PLAYER_STATS.HUNGER_RATE * seconds_elapsed;
        
        // Update hunger
        const currentHunger = Hunger.value[player];
        
        // Decrease hunger over time using calculated drain rate
        Hunger.value[player] = Math.max(PLAYER_STATS.MIN_HUNGER, currentHunger - hungerRate);
        
        // Check if player is starving
        if (Hunger.value[player] === PLAYER_STATS.MIN_HUNGER) {
            // Starvation is now handled by the health system
        }
    }
    
    return world;
}

export function thirstSystem(world) {
    const players = playerQuery(world);
    const time_delta = world.delta || 16.67; // Default to ~60fps if delta not provided
    const seconds_elapsed = time_delta / 1000; // Convert ms to seconds
    
    for (const player of players) {
        // Get the correct thirst rate from the dynamically calculated getter
        const thirstRate = PLAYER_STATS.THIRST_RATE * seconds_elapsed;
        
        // Update thirst
        const currentThirst = Thirst.value[player];
        
        // Decrease thirst over time using calculated drain rate
        Thirst.value[player] = Math.max(PLAYER_STATS.MIN_THIRST, currentThirst - thirstRate);
        
        // Check if player is in water
        const tile = getTileAtPosition(world, Position.x[player], Position.y[player]);
        if (tile !== null && Tile.type[tile] === 0) {
            // Player is in water, check if it's freshwater
            // For now, we'll assume all water is freshwater
            Thirst.canDrink[player] = 1;
        } else {
            Thirst.canDrink[player] = 0;
        }
        
        // Check if player is dehydrated
        if (Thirst.value[player] === PLAYER_STATS.MIN_THIRST) {
            // Dehydration damage is handled by the health system
        }
    }
    
    return world;
} 